/**
 * Hook for auto-dismissing flash notifications
 */
import {safePushEvent} from '../lib/safe_push.js'

export default {
  mounted () {
    // Auto-dismiss after 3 seconds
    this.timeout = setTimeout(() => {
      this.dismiss()
    }, 3000)

    // Pause auto-dismiss on hover
    this.el.addEventListener('mouseenter', () => {
      if (this.timeout) {
        clearTimeout(this.timeout)
        this.timeout = null
      }
    })

    // Resume auto-dismiss on mouse leave
    this.el.addEventListener('mouseleave', () => {
      this.timeout = setTimeout(() => {
        this.dismiss()
      }, 2000)
    })
  },

  dismiss () {
    // Fade out then hide
    this.el.style.opacity = '0'
    this.el.style.transition = 'opacity 200ms ease-out'
    setTimeout(() => {
      // Push the clear-flash event to the server
      const kind = this.el.dataset.kind
      if (kind) {
        safePushEvent(this, 'lv:clear-flash', { key: kind })
      }
      this.el.style.display = 'none'
    }, 200)
  },

  destroyed () {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }
}
